import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  Text,
  VStack,
  Box,
  Divider,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import useAxios from "axios-hooks";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

import Card from "components/card/Card";
import { toastState } from "atoms/toastState";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import { updateUserFinancialDetailsDrawerState } from "atoms/updateUserFinancialDetailsDrawerState";
import { loggedInUserState } from "atoms/loggedInUserState";
import { 
  BankAccountDetailsFields, 
  BusinessDetailsFields, 
  DocumentVerificationFields 
} from "../variables/options";
import logger from "infra/logger";

//   import { updateTenantDetailsDrawerState } from "atoms/updateTenantDetailsDrawerState";

const UpdateUserFinancialDetailsDrawer = (props) => {
  const setToast = useSetRecoilState(toastState);
  const [drawerState, setDrawerState] = useRecoilState(
    updateUserFinancialDetailsDrawerState
  );

  const loggedInUser = useRecoilValue(loggedInUserState);

  // get reciolVAlue form loggedInUserState from atoms
  // you can get the tenant id from recoilvalue

  const [userFinancialDetails, setUserFinancialDetails] = useState({
    BankAccountNo: "",
    BankName: "",
    IfscCode: "",
    BeneficiaryName: "",
    BusinessName: "",
    BusinessPincode: "",
    BusinessState: "",
    BusinessCity: "",
    BusinessAddress: "",
    PanCard: "",
    GstNo: "",
  });

  const validationSchema = yup.object().shape({
    BankAccountNo: yup.string(),
    BankName: yup.string(),
    IfscCode: yup.string(),
    BeneficiaryName: yup.string(),
    BusinessName: yup.string(),
    BusinessPincode: yup.string().matches(/^\d{6}$/, "Pincode must be 6 digits"),
    BusinessState: yup.string(),
    BusinessCity: yup.string(),
    BusinessAddress: yup.string().max(100, "Business address cannot exceed 100 characters"),
    PanCard: yup
      .string()
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN card number"),
    GstNo: yup.string(),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    register,
    setValue,
    getValues,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const [
    { loading: UserFinancialDetailsLoading },
    getUserFinancialDetails,
    cancelRequest,
  ] = useAxios(
    { method: "GET", url: `/api/user/profile/${loggedInUser?.userId}` },
    { manual: true }
  );

  const [
    {
      data: UpdateUserAccountDetails,
      loading: updateUserAccountDetailsLoading,
    },
    updateTenantAccountDetails,
  ] = useAxios(
    {
      method: "PATCH",
      url: `/api/user/update/financials/${loggedInUser?.userId}`,
    },
    { manual: true }
  );
  const closeAccountHandler = () => {
    setDrawerState(null);
  };
  const getUserAccountDetails = async () => {
    try {
      const response = await getUserFinancialDetails();
      const data = response.data.data;
      setValue("BankName", data?.BankName);
      setValue("BankAccountNo", data?.BankAccountNo);
      setValue("IfscCode", data?.IfscCode);
      setValue("BeneficiaryName", data?.BeneficiaryName);
      setValue("BusinessName", data?.BusinessName);
      setValue("BusinessPincode", data?.BusinessPincode);
      setValue("BusinessState", data?.BusinessState);
      setValue("BusinessCity", data?.BusinessCity);
      setValue("BusinessAddress", data?.BusinessAddress);
      setValue("PanCard", data?.PanCard);
      setValue("GstNo", data?.GstNo);

      setUserFinancialDetails((prev) => {
        return {
          ...prev,
          BankName: data?.BankName,
          BankAccountNo: data?.BankAccountNo,
          IfscCode: data?.IfscCode,
          BeneficiaryName: data?.BeneficiaryName,
          BusinessName: data?.BusinessName,
          BusinessPincode: data?.BusinessPincode,
          BusinessState: data?.BusinessState,
          BusinessCity: data?.BusinessCity,
          BusinessAddress: data?.BusinessAddress,
          PanCard: data?.PanCard,
          GstNo: data?.GstNo,
        };
      });
    } catch (error) {
      logger.log(error);
      if (error?.code != "ERR_CANCELED") {
        setToast({
          isOpen: true,
          title: "Error occured while getting user financial details",
          status: "error",
        });
        closeAccountHandler();
      }
    }
  };

  const UpdateAccountHandler = async () => {
    const formValues = getValues();
    let userFinancialDetailsUpdate = {};

    // Bank Account Details
    if (
      formValues.BankName.trim() !== "" &&
      formValues.BankName.trim() !== userFinancialDetails?.BankName
    ) {
      userFinancialDetailsUpdate["BankName"] = formValues?.BankName.trim();
    }
    if (
      formValues.BankAccountNo.trim() !== "" &&
      formValues.BankAccountNo.trim() !== userFinancialDetails?.BankAccountNo
    ) {
      userFinancialDetailsUpdate["BankAccountNo"] =
        formValues?.BankAccountNo.trim();
    }
    if (
      formValues.BeneficiaryName.trim() !== "" &&
      formValues.BeneficiaryName.trim() !==
        userFinancialDetails?.BeneficiaryName
    ) {
      userFinancialDetailsUpdate["BeneficiaryName"] =
        formValues?.BeneficiaryName.trim();
    }
    if (
      formValues.IfscCode.trim() !== "" &&
      formValues.IfscCode.trim() !== userFinancialDetails?.IfscCode
    ) {
      userFinancialDetailsUpdate["IfscCode"] = formValues?.IfscCode.trim();
    }

    // Business Details
    if (
      formValues.BusinessName &&
      formValues.BusinessName.trim() !== "" &&
      formValues.BusinessName.trim() !== userFinancialDetails?.BusinessName
    ) {
      userFinancialDetailsUpdate["BusinessName"] = formValues.BusinessName.trim();
    }
    if (
      formValues.BusinessPincode &&
      formValues.BusinessPincode.trim() !== "" &&
      formValues.BusinessPincode.trim() !== userFinancialDetails?.BusinessPincode
    ) {
      userFinancialDetailsUpdate["BusinessPincode"] = formValues.BusinessPincode.trim();
    }
    if (
      formValues.BusinessState &&
      formValues.BusinessState.trim() !== "" &&
      formValues.BusinessState.trim() !== userFinancialDetails?.BusinessState
    ) {
      userFinancialDetailsUpdate["BusinessState"] = formValues.BusinessState.trim();
    }
    if (
      formValues.BusinessCity &&
      formValues.BusinessCity.trim() !== "" &&
      formValues.BusinessCity.trim() !== userFinancialDetails?.BusinessCity
    ) {
      userFinancialDetailsUpdate["BusinessCity"] = formValues.BusinessCity.trim();
    }
    if (
      formValues.BusinessAddress &&
      formValues.BusinessAddress.trim() !== "" &&
      formValues.BusinessAddress.trim() !== userFinancialDetails?.BusinessAddress
    ) {
      userFinancialDetailsUpdate["BusinessAddress"] = formValues.BusinessAddress.trim();
    }

    // Document Verification
    if (
      formValues.PanCard &&
      formValues.PanCard.trim() !== "" &&
      formValues.PanCard.trim() !== userFinancialDetails?.PanCard
    ) {
      userFinancialDetailsUpdate["PanCard"] = formValues.PanCard.trim();
    }

    if (
      formValues.GstNo &&
      formValues.GstNo.trim() !== "" &&
      formValues.GstNo.trim() !== userFinancialDetails?.GstNo
    ) {
      userFinancialDetailsUpdate["GstNo"] = formValues.GstNo.trim();
    }

    if (Object.keys(userFinancialDetailsUpdate).length > 0) {
      try {
        const response = await updateTenantAccountDetails({
          data: userFinancialDetailsUpdate,
        });
        setToast({
          isOpen: true,
          title: "User Financial details Updated",
          status: "success",
        });
        props.update();
        closeAccountHandler();
        getUserAccountDetails();
      } catch (error) {
        const err = error?.response?.data?.error;
        logger.log(error);
        setToast({
          isOpen: true,
          title: "Error occured when updating Details",
          description: err ? err : null,
          status: "error",
        });
      }
    } else {
      setToast({
        isOpen: true,
        title: "nothing new to update",
        status: "warning",
      });
    }
  };

  useEffect(() => {
    getUserAccountDetails();
    return () => cancelRequest();
  }, []);

  return (
    <Drawer
      isOpen={drawerState?.isOpen}
      placement="right"
      onClose={closeAccountHandler}
      size="md"
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>Update User Financial Details</DrawerHeader>
        <DrawerBody>
          {!UserFinancialDetailsLoading && !updateUserAccountDetailsLoading ? (
            <>
              <VStack spacing={6} align="stretch">
                {/* Bank Account Details Section */}
                <Card>
                  <VStack spacing={4} align="stretch">
                    <Box>
                      <Text fontSize="lg" fontWeight="bold" mb={4} color="brand.500">
                        Bank Account Details
                      </Text>
                      <form>
                        {BankAccountDetailsFields.map((item, index) => (
                          <Flex key={index} mb="20px" alignItems="center">
                            <Controller
                              name={item.name}
                              control={control}
                              render={({ field }) => (
                                <FormControl
                                  flexDirection="row"
                                  isInvalid={errors[item.name]}
                                >
                                  <FormLabel fontSize={16}>{item.label}</FormLabel>
                                  <Input
                                    {...field}
                                    focusBorderColor="brand.500"
                                    fontSize="sm"
                                    placeholder={item.placeholder}
                                    width="400px"
                                    height="50px"
                                    type={item.type}
                                  />
                                  <FormHelperText color={"brand.500"}>
                                    {item.helper}
                                  </FormHelperText>
                                  <FormErrorMessage mb={"20px"}>
                                    {errors[item.name] && errors[item.name].message}
                                  </FormErrorMessage>
                                </FormControl>
                              )}
                            />
                          </Flex>
                        ))}
                      </form>
                    </Box>
                  </VStack>
                </Card>

                {/* Business Details Section */}
                <Card>
                  <VStack spacing={4} align="stretch">
                    <Flex justifyContent="space-between" alignItems="center">
                      <Text fontSize="lg" fontWeight="bold" color="brand.500">
                        Business Details
                      </Text>
                      <Button
                        size="sm"
                        variant="outline"
                        colorScheme="brand"
                        color="brand.500"
                        borderColor="brand.500"
                        _hover={{ bg: "brand.500", color: "white" }}
                      >
                        Edit Details
                      </Button>
                    </Flex>
                    <Box>
                      <form>
                        {BusinessDetailsFields.map((item, index) => (
                          <Flex key={index} mb="20px" alignItems="center">
                            <Controller
                              name={item.name}
                              control={control}
                              render={({ field }) => (
                                <FormControl
                                  flexDirection="row"
                                  isInvalid={errors[item.name]}
                                >
                                  <FormLabel fontSize={16}>{item.label}</FormLabel>
                                  <Input
                                    {...field}
                                    focusBorderColor="brand.500"
                                    fontSize="sm"
                                    placeholder={item.placeholder}
                                    width="400px"
                                    height="50px"
                                    type={item.type}
                                    maxLength={item.maxLength}
                                  />
                                  <FormHelperText color={"brand.500"}>
                                    {item.helper}
                                  </FormHelperText>
                                  <FormErrorMessage mb={"20px"}>
                                    {errors[item.name] && errors[item.name].message}
                                  </FormErrorMessage>
                                </FormControl>
                              )}
                            />
                          </Flex>
                        ))}
                      </form>
                    </Box>
                  </VStack>
                </Card>

                {/* Document Verification Section */}
                <Card>
                  <VStack spacing={4} align="stretch">
                    <Box>
                      <Text fontSize="lg" fontWeight="bold" mb={4} color="brand.500">
                        Document Verification
                      </Text>
                      <form>
                        {DocumentVerificationFields.map((item, index) => (
                          <Flex key={index} mb="20px" alignItems="center">
                            <Controller
                              name={item.name}
                              control={control}
                              render={({ field }) => (
                                <FormControl
                                  flexDirection="row"
                                  isInvalid={errors[item.name]}
                                >
                                  <FormLabel fontSize={16}>{item.label}</FormLabel>
                                  <Input
                                    {...field}
                                    focusBorderColor="brand.500"
                                    fontSize="sm"
                                    placeholder={item.placeholder}
                                    width="400px"
                                    height="50px"
                                    type={item.type}
                                  />
                                  <FormHelperText color={"brand.500"}>
                                    {item.helper}
                                  </FormHelperText>
                                  <FormErrorMessage mb={"20px"}>
                                    {errors[item.name] && errors[item.name].message}
                                  </FormErrorMessage>
                                </FormControl>
                              )}
                            />
                          </Flex>
                        ))}
                      </form>
                    </Box>
                  </VStack>
                </Card>
              </VStack>
            </>
          ) : (
            <LoadingSpinner />
          )}
        </DrawerBody>
        <DrawerFooter>
          <Button variant="outline" mr={3} onClick={closeAccountHandler}>
            Cancel
          </Button>
          <Button
            bg="brand.500"
            color="white"
            colorScheme="brand"
            onClick={handleSubmit(UpdateAccountHandler)}
            isLoading={updateUserAccountDetailsLoading}
          >
            Update
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default UpdateUserFinancialDetailsDrawer;
